import dayjs from 'dayjs';

export default {
  methods: {
    parseDate(date) {
      if (!date || date.length < 10) return null;

      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    formatDate(date) {
      if (!date) return null;

      date = this.getOnlyDateIgnoringTimestamp(date);
      return dayjs(date).format('DD/MM/YYYY');
    },

    formatDateHour(date) {
      if (!date) return null;

      let data = new Date(date);
      return dayjs(data).format('DD/MM/YYYY HH:mm');
    },

    parseMonth(date) {
      if (!date || date.length < 7) return null;

      const [month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}`;
    },

    formatMonth(date) {
      if (!date) return null;

      date = this.getOnlyDateIgnoringTimestamp(date);
      return dayjs(date).format('MM/YYYY');
    },

    formatDateToPicker(date) {
      if (!date) return null;

      date = this.getOnlyDateIgnoringTimestamp(date);
      return dayjs(date).format('YYYY-MM-DD');
    },

    formatMonthToPicker(date) {
      if (!date) return null;

      date = this.getOnlyDateIgnoringTimestamp(date);
      return dayjs(date).format('YYYY-MM');
    },

    getOnlyDateIgnoringTimestamp(date) {
      if (date && date.length > 10) {
        date = date.substr(0, 10);
      }
      return date;
    }
  }
};
